export const SERVERGROUP = 'SERVERGROUP'